module.exports = __webpack_public_path__ + "c0dbf9ac2aa35fc5ccb343e29d6fcb0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/radiant.png
// module id = 772
// module chunks = 0